import React from "react";
import "../../index.css";
import { StudentHomePage } from "../../Students/pages/StudentHomePage";
import { Admin } from "../../components/Admin/Admin";
import { useSelector } from "react-redux";
import Spinner from "../../components/FormElements/Spinner";
import { AlertDialog } from "../../components/UIElements/AlertDialog";
import { Box } from "@chakra-ui/react";

const Home = () => {
  const { user, isSuccess, isLoading, isError } = useSelector(
    (state) => state.auth
  );

  if (isLoading) return <Spinner />;
  if (isError)
    return (
      <AlertDialog
        variant="error"
        message="Error loading results, please log out and try again."
      />
    );

  return user && isSuccess && !isLoading ? (
    <Box maxWidth="1300px" margin="auto" className="responsive-page-content">
      {user.role ? <Admin /> : <StudentHomePage />}
    </Box>
  ) : (
    <Spinner />
  );
};

export default Home;
